<template>
    <div class="w-full flex flex-column align-items-center mt-5" style="color: var(--theme-font-color);">
        <div style="height: 2.9rem;"></div>
        <span style="color: var(--theme-font-color); font-size: var(--login-maintitle-font-size); font-weight: var(--login-maintitle-font-weight);">Help Center</span>
        <span style="color: var(--theme-font-color); font-size: var(--login-subtitle-font-size); font-weight: var(--login-subtitle-font-weight);" class="mt-6">Redirecting to the Softron Zendesk link...</span>
        <LoadingSpinner/>


        <span style="font-size: var(--subtext-font-size); font-weight: var(--text-font-weight);" class="mt-8">
            The page does not redirect properly ? Try again by
            <a style="text-decoration: none;" class="ml-1 justify-self-start flex align-items-center justify-content-center" :href="helpRedirectionLink" target="_self">
                <span id="redirection-link-text" class="cursor-pointer" style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">clicking here</span>
            </a>
            .
        </span>
  </div>
</template>

<script setup>
// --- IMPORTS ---
import { onMounted } from 'vue';
// vue
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';

// Variable
const helpRedirectionLink = "https://softron.zendesk.com/hc/en-us/sections/14666349935516-Softron-License-Manager-New-2024-Activations"

onMounted(() => {
  // Redirect to an external link
  window.location.href = helpRedirectionLink;
});
</script>

<style scoped>
/* Redirection link */
#redirection-link-text {
    text-decoration: none;
    color: var(--button-normal-color);
}
#redirection-link-text:visited {
    color: var(--button-normal-color);
}
#redirection-link-text:hover {
    border-bottom: 1px solid var(--button-normal-color);
}
</style>